module.exports = __webpack_public_path__ + "img/swift-boostergreen-glx-naranja-monarca.94bdb557.png";